import HttpRequestService from "./HttpRequestService";

const PricingService = {};

const cntrlName = "GetPlans";

//API for get all data
PricingService.getPlanList = function () {
  return HttpRequestService.get(cntrlName);
};


export default PricingService;
